module.exports = __webpack_public_path__ + "static/media/ball_5_4.20caf3e9.mp3";